<template>
  <div class="f-signaturesCounter">
    <div class="text-center">
      <p>
        <span class="number-sign-style">
          <IOdometer :value="signatures"/>
        </span> {{activeLanguage.haveSigned}}
      </p>
    </div>
    <b-progress :max="max" class="mb-3 rounded-edges" height="2rem">
      <b-progress-bar variant="danger" :value="petitionSignatures" class="line-style"></b-progress-bar>
      <div class="arrow-right-fit-finish"></div>
    </b-progress>
    <div>
      <p class="font-weight-bold">
        {{activeLanguage.letsGetTo}} {{maxToString}}
      </p>
    </div>
  </div>
</template>

<script>
  import IOdometer from 'vue-odometer'
  import 'odometer/themes/odometer-theme-default.css'

  export default {
    name: 'SignaturesCounter',
    components: {IOdometer},
    data () {
      return {
        signatures: 0,
        signaturesMaxBound: 0,
        max: 3000,
        signaturesForProgress: 0,
        effectiveSignatures: 0
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      petitionSignatures () {
        return this.signaturesForProgress
      },
      maxToString () {
        return this.max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    methods: {
      loadPetitionSigns () {
        let self = this
        this.$http.get(this.$PATH_NAME + 'statistics/petitionPage/').then((response) => {
          if (response.status === 200) {
            this.slowAnimateProgress(response.body.statistics.signatures)
            this.effectiveSignatures = response.body.statistics.signatures
            this.setMaxGoal()
            setTimeout(function () {
              if (response.body.statistics.signatures > 30 && response.body.statistics.signatures >= 1000) {
                self.signatures = response.body.statistics.signatures - 30
              } else if (response.body.statistics.signatures < 1000) {
                self.signatures = response.body.statistics.signatures - 15
              } else {
                self.signatures = response.body.statistics.signatures
              }
              self.signaturesMaxBound = response.body.statistics.signatures
              setTimeout(function () {
                self.counterIncrementer()
              }, 500)
            }, 200)
          }
        }
        )
      },
      slowAnimateProgress (signatures) {
        let repetitions = 15
        let slice = signatures / repetitions
        let self = this
        this.setIntervalX(function () {
          self.signaturesForProgress += slice
        }, 100, repetitions)
      },
      setIntervalX (callback, delay, repetitions) {
        let x = 0
        let intervalID = window.setInterval(function () {
          callback()

          if (++x === repetitions) {
            window.clearInterval(intervalID)
          }
        }, delay)
      },
      setMaxGoal () {
        while (this.effectiveSignatures - this.max >= 0) {
          this.max += 3000
        }
      },
      counterIncrementer () {
        if (this.signatures < this.signaturesMaxBound) {
          const that = this
          let randomRepetition = Math.floor(Math.random() * (3000 - 1500 + 1)) + 1500
          setTimeout(function () {
            that.signatures += Math.floor(Math.random() * (3 - 1 + 1)) + 1
            that.counterIncrementer()
          }, randomRepetition)
        }
      }
    },
    mounted () {
      this.loadPetitionSigns()
    }
  }
</script>

<style scoped>

  .f-signaturesCounter {
    margin-left: 5%;
    margin-right: 5%;
  }

  .rounded-edges {
    border-radius: 10000rem !important;
    margin-left: 10%;
    margin-right: 10%;
  }

  .line-style {
    background: linear-gradient(to right, #FFA600, #c41c21);
  }

  .arrow-right-fit-finish {
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid #c41c21;
    position: relative;
    display: inline-block;
  }

  .number-sign-style {
    font-weight: bold;
    font-size: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/signPetitionPageComponents/SignaturesCounter.vue